<template>
	<div :class="[
		'form-group',
		{'is-small': small},
		{'is-compact': compact},
		{'has-error' : hasError}
	]">
		<label :for="name" class="label">{{ label }}</label>
		<input
			:type="type" :name="name" :value="value" :class="inputClasses"
			@input="$emit('input', $event.target.value)"
		/>
		<FormError :error="hasError" :message="errorMessage" />
	</div>
</template>

<script>
import FormError from "@/components/formfields/FormError"

export default {
	inheritAttrs: false,

	components: { FormError },

	props: {
		type: {
			type: String,
			default: 'text'
		},
		inputClasses: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		small: {
			type: Boolean,
			default: false
		},
		compact: {
			type: Boolean,
			default: false
		},
		hasError: {
			type: Boolean,
			default: false
		},
		errorMessage: {
			type: String,
			default: 'Invalid input'
		},
		value: {
			type: String,
			default: ""
		}
	},

	name: "FormInput",
}
</script>

<style lang="scss" scoped></style>
